import { render, staticRenderFns } from "./print-labels.vue?vue&type=template&id=f259a514&scoped=true"
import script from "./print-labels.vue?vue&type=script&lang=ts"
export * from "./print-labels.vue?vue&type=script&lang=ts"
import style0 from "./print-labels.vue?vue&type=style&index=0&id=f259a514&lang=scss"
import style1 from "./print-labels.vue?vue&type=style&index=1&id=f259a514&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f259a514",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f259a514')) {
      api.createRecord('f259a514', component.options)
    } else {
      api.reload('f259a514', component.options)
    }
    module.hot.accept("./print-labels.vue?vue&type=template&id=f259a514&scoped=true", function () {
      api.rerender('f259a514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ops/print-labels.vue"
export default component.exports